export const PAYMENT_PENDING = 'pending';
export const PAYMENT_FULFILLED = 'paid';
